import GestionPaiementToolbar from "./gestion-paiement-toolbar";
import {Button} from "devextreme-react/button";
import DataGrid, {Column, DataGridRef, Editing, Lookup} from "devextreme-react/data-grid";
import React, {useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState} from "react";
import useApi, {IApiErreur} from "../../hooks/useApi";
import ITypePaiement from "../../models/ITypePaiement";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import IPaiement from "../../models/IPaiement";
import Guid from "../../models/Guid";
import useLookUpBase from "../../components/selectbox/LookupBase";
import useClient from "../../components/selectbox/client";
import dxDataGrid, {FocusedRowChangedEvent, InitNewRowEvent, Row} from "devextreme/ui/data_grid";
import {ClickEvent} from "devextreme/ui/button";
import {useAuth} from "../../contexts/auth";
import {custom} from "devextreme/ui/dialog";
import "./gestion-paiement.css";
import PopupPage, {useContextPopupPage} from "../../components/popups/PopupPage";
import {ICustomRule} from "../../hooks/useCustomDataSource";
import GestionSaisieDePaiement from "../gestion-saisie-de-paiement/gestion-saisie-de-paiement";
import useTpv from "../../hooks/useTpv";
import useMessageBox from "../../hooks/useMessageBox";
import {TypeAuxiliaire} from "../../models/TypeAuxiliaire";

const buttonAttributes = {
    class: 'popup-depot-bouton-cta'
}

export interface ICreditCard {
    cardNumber: string,
    expirationMonth: string,
    expirationYear: string,
    cVV: string,
    cardHolderName: string,
}

export enum TransactionType {
    Undefined = -1,
    Purchase,
    Refund,
    Preauth,
    PreauthCompletion,
    PreauthCancellation
}

interface IParamPaiementWeb {

    transactionType: TransactionType,
    idFacturationEntete: Guid,
    typeAuxiliaire: TypeAuxiliaire,
    idAuxiliaire: Guid,
    idClient: Guid,
    paiementProfile?: string,
    carteCredit: ICreditCard,
    montant: number,
    transactionId: string,
    idUsager: Guid

}

interface IGestionPaiementProps {
    id?: Guid,
    typeAuxiliaire: TypeAuxiliaire,
    idClient?: Guid,
    montantAuxiliaireTotal: number,
    saveBtnRef?: any
}

let abortContoller: { [index: string]: AbortController } = {};

const GestionPaiement = ({id, typeAuxiliaire, montantAuxiliaireTotal, idClient, saveBtnRef}: IGestionPaiementProps) => {
    const {data: typePaiementsBtn, getData: getTypePaiementBtn} = useApi<ITypePaiement[]>('typePaiement/getBoutonPaiement', [] as ITypePaiement[]);
    const {data: typePaiements, getData: getTypePaiement} = useApi<ITypePaiement[]>('typePaiement', [] as ITypePaiement[]);
    const path = typeAuxiliaire === 'RE' ? 'reservation' : 'facturation';
    const {data: paiements, setData: setPaiements, getData: getPaiements, postData: postPaiements, fetchData: fecthPaiement} = useApi<IPaiement[]>(`${path}/paiement/${id}`, []);
    const {data: paiement, setData: setPaiement, getData: getPaiement, postData: postPaiement} = useApi<IPaiement>(`paiement`, {} as IPaiement);
    const [focusedRow, setFocusedRow] = useState<IPaiement>();
    const dataGridRef = useRef<DataGridRef>(null);
    const {ClientSelectBox, PopupGestionClient} = useClient();
    const {editorOptions: usagerEditorOptions} = useLookUpBase({controllerName: "usager"})
    const {user} = useAuth();
    const [isFieldModifier, setIsFieldModifier] = useState(false);
    const [isSaisiePaiement, setIsSaisiePaiement] = useState<"tpv" | "bambora" | boolean>(false);
    const [isModeModify, setIsModeModify] = useState(false);
    const {editorOptions: typePaiementEditorOptions} = useLookUpBase({controllerName: 'typePaiement', showClear: isModeModify});
    const [erreurs, setErreurs] = useState<IApiErreur[]>([]);
    const {setSelectedValue, setDoitSauvegarder, onClose: onClosePopup} = useContextPopupPage();
    const [validationRules, setValidationRules] = useState<ICustomRule[]>([]);
    const [montantDu, setMontantDu] = useState(0)
    const [validationRulesInitialized, setValidationRulesInitialized] = useState(false);
    const {MessageBox, setIsMessageBoxOpen, setButtonType, setMessage, setTitle} = useMessageBox();
    const idPaiementRefuse = useMemo(() => typePaiements?.find(f => f.modePaiement === 11)?.idTypePaiement, [typePaiements]);

    useImperativeHandle(saveBtnRef, () => ({
        async sauvegarder() {
            if (isFieldModifier)
                await sauvegarderClick();
        }
    }))

    const dataStore = useMemo(() => new CustomStore({
        key: "idPaiement",
        load: async () => {
            return paiements;
        },
        insert: async (values) => {
            setIsFieldModifier(true);
            setIsModeModify(true);
            const newRow = await getPaiement({customPath: 'paiement/default', returnOnly: true});
            const row: IPaiement = {
                ...newRow,
                ...values,
                idClient: idClient || Guid.empty,
                idAuxiliaire: typeAuxiliaire === 'RE' ? id || Guid.empty : Guid.empty,
                idFacturationEntete: typeAuxiliaire !== 'RE' ? id || Guid.empty : Guid.empty,
                idUsagerModification: user?.idUsager || Guid.empty,
                idUsagerCreation: user?.idUsager || Guid.empty,
                dateCreation: new Date(),
                dateModification: new Date()
            }
            setPaiements((prev) => {
                return [...(prev || []), row]
            });
            return row;
        },
        update: async (key, values) => {
            const currentRow = {...paiements?.find(f => f.idPaiement.equals(key)), ...values}

            currentRow.idUsagerModification = user?.idUsager as Guid;
            currentRow.dateModification = new Date();

            setIsFieldModifier(true);
            setIsModeModify(true);
            setPaiements((prev) => {
                return [...(prev || []).filter(f => !f.idPaiement.equals(key)), currentRow]
            })
        },
        remove: async key => {
            setIsFieldModifier(true);
            setIsModeModify(true);
            const rowEffacer: IPaiement[] = (paiements || [] as IPaiement[]).filter(f => f.idPaiement.equals(key)).map(p => {
                p.dateSuppression = new Date();
                p.idUsagerSuppression = user?.idUsager || Guid.empty;
                return p
            });

            setPaiements(prev => {
                return [...(prev || [] as IPaiement[]).filter(f => !f.idPaiement.equals(key)), ...rowEffacer]
            });
        }
    }), [paiements, setPaiements, getPaiement, typeAuxiliaire, id, user?.idUsager])

    const dataSource = useMemo(() => new DataSource({
        key: "idPaiement",
        store: dataStore,
        reshapeOnPush: true
    }), [dataStore])

    const onFocusedRowChanged = useCallback((params: FocusedRowChangedEvent<IPaiement>) => {
        setFocusedRow(params.row?.data)
    }, []);

    const ajouterClick = useCallback(() => dataGridRef.current?.instance().addRow(), [dataGridRef.current?.instance]);
    const annulerClick = useCallback(() => {
        getPaiements()
        setIsModeModify(false);
        setIsFieldModifier(false);
    }, [getPaiements]);

    const modifierOptions = useMemo(() => ({disabled: isModeModify, click: () => setIsModeModify(true)}), [isModeModify]);
    const annulerOptions = useMemo(() => ({
        disabled: !isModeModify,
        click: annulerClick
    }), [isModeModify, annulerClick]);

    const onInitNewRow = useCallback((e: InitNewRowEvent<IPaiement>) => {
        e.promise = getPaiement({customPath: 'paiement/default', returnOnly: true})
            .then((newRow) => {
                e.data = {...newRow, idUsagerModification: user?.idUsager || Guid.empty, idUsagerCreation: user?.idUsager || Guid.empty, typeAuxiliaire: typeAuxiliaire, montant: Number((montantDu || 0).toFixed(2)), idAuxiliaire: typeAuxiliaire === 'RE' ? id || Guid.empty : Guid.empty, idFacturationEntete: typeAuxiliaire !== 'RE' ? id || Guid.empty : Guid.empty}
            })
    }, [getPaiement, user?.idUsager, typeAuxiliaire, montantDu, id])

    const onClickBtnRapide = useCallback(async (e: ClickEvent) => {
        dataSource?.store().insert({idTypePaiement: e.element.id, idUsagerModification: user?.idUsager || Guid.empty, idUsagerCreation: user?.idUsager || Guid.empty, typeAuxiliaire: typeAuxiliaire, montant: Number((montantDu || 0).toFixed(2)), idAuxiliaire: typeAuxiliaire === 'RE' ? id || Guid.empty : Guid.empty, idFacturationEntete: typeAuxiliaire !== 'RE' ? id || Guid.empty : Guid.empty});
    }, [dataSource, user?.idUsager, typeAuxiliaire, montantDu, id]);

    const filterValue = useMemo(() => ["dateSuppression", "=", null], []);

    useEffect(() => {
        fecthPaiement("get", {customPath: `paiement/getValidation`, returnOnly: true}).then((result: string[]) => {
            if (result) {
                setValidationRules(result.map(fieldName => {
                    return {type: "async", message: "", reevaluate: true, propertyName: fieldName} as ICustomRule
                }))
                dataGridRef.current?.instance().refresh()
            }
        })

    }, [dataGridRef])

    const validate = useCallback(async (data: IPaiement | undefined) => {
        const result = await fecthPaiement("post", {
            customPath: `paiement/ValidateModel`,
            body: data as unknown as object,
            returnOnly: true
        });
        return result as unknown[] as IApiErreur[];
    }, [fecthPaiement]);

    const validationCallback = useCallback((e: any) => {
        return new Promise(async (resolve, reject) => {
            if (!isModeModify) return resolve(undefined);
            try {

                const result: IApiErreur[] = await validate(e.data);
                const erreur = result.find(f => f.propertyName.toLowerCase() === e.rule.propertyName.toLowerCase())
                if (erreur) {
                    reject(erreur.errorMessage);
                }
            } catch (ex) {
                resolve(undefined);
            }
            resolve(undefined);
        })
    }, [isModeModify, validate])

    const customizeColumns = useCallback((items: any) => {
        if (!isModeModify || !validationRules || validationRules.length === 0 || validationRulesInitialized) return;

        items.forEach((col: any) => {
            if (col.dataField) {
                const rule = validationRules.find(f => f.propertyName.toLowerCase() === col.dataField?.toLowerCase())//{type: "async", message: "", validationCallback, reevaluate: true} as unknown as ICustomRule
                if (rule) {
                    rule.validationCallback = validationCallback;
                    col.validationRules = [rule];
                }
            }
        });
        //setValidationRulesInitialized(true);
    }, [validationRules, isModeModify, validationCallback, focusedRow])

    function isValidationErreur(arg: any[]): arg is IApiErreur[] {
        const result = arg && arg.length > 0 && arg[0] && arg[0].propertyName && typeof (arg[0].propertyName) === 'string'
        return result;
    }


    const sauvegarderClick = async () => {
        try {
            abortContoller['paiementSauvegarde'] && abortContoller['paiementSauvegarde'].abort();
            abortContoller['paiementSauvegarde'] = new AbortController();
            let hasErrors = false;
            for (const paiement of paiements || []) {

                const validationErreurs = await validate(paiement)
                if (validationErreurs && validationErreurs.length > 0) {
                    //console.log(validationErreurs)
                    let msgError = "Une ou plusieurs données sont manquantes </br> <ul>";
                    validationErreurs.forEach(err => {
                        msgError += `</br> <li>${err.errorMessage}</li>`
                        //console.log(err)
                    });
                    msgError += "</ul>";
                    let myDialog = custom({
                        dragEnabled: true,
                        title: "Erreurs",
                        messageHtml: msgError,
                        buttons: [{
                            text: "OK",
                            onClick: (e) => {
                                return {buttonText: e.component.option("text")}
                            }
                        }]
                    });
                    myDialog.show()
                    hasErrors = true;
                    setErreurs(validationErreurs);
                }
            }

            if (hasErrors) {
                throw new Error("Erreur lors de la sauvegarde")
            }


            const result = await fecthPaiement("post", {
                customPath: 'paiement/sauvegarder',
                body: {selectedDataRow: paiements as unknown as object, IdUsager: user?.idUsager},
                returnOnly: true,
                abortSignal: abortContoller['paiementSauvegarde'].signal
            })

            if (isValidationErreur(result)) {
                setErreurs(result as IApiErreur[])
            } else {
                setErreurs([]);

                getPaiements().then(() => {
                    setIsModeModify(false);
                    setIsFieldModifier(false);
                });
            }

        } catch (exception) {
            //console.log((exception))
        }
    };

    useEffect(() => {
        getTypePaiementBtn();
        getTypePaiement();
        getPaiements();

    }, []);

    useEffect(() => {
        if (!setSelectedValue || !id) return;

        setSelectedValue(id)
    }, [setSelectedValue]);

    useEffect(() => {
        setMontantDu(Number((montantAuxiliaireTotal - (paiements?.filter(f => f.dateSuppression === null) || [])?.reduce((total, paiement) => total += paiement.montant, 0)).toFixed(2)));
    }, [paiements]);

    useEffect(() => {
        setDoitSauvegarder && setDoitSauvegarder(isFieldModifier);
    }, [isFieldModifier]);

    const allowDeleting = useCallback((options: { component: dxDataGrid; row: Row<IPaiement>; }) => {
        return options.row.data?.maj === 0 && options.row.data.z === '' && (options.row.data.noDepot === '0' || options.row.data.noDepot === '') && options.row.data.noRecu === '' && options.row.data.recuTPV === '' && options?.row?.data?.idTypePaiement instanceof Guid && !options?.row?.data?.idTypePaiement?.equals(idPaiementRefuse);
    }, [idPaiementRefuse])

    const allowUpdating = useCallback((options: { component: dxDataGrid<any, any>, row: Row }) => {
        return isModeModify && allowDeleting(options);
    }, [isModeModify, allowDeleting]);

    const buttonsTypePaiement = useMemo(() => typePaiementsBtn?.map((typePaiement) => <Button
            key={typePaiement?.idTypePaiement?.toString()}
            text={typePaiement.description}
            id={typePaiement?.idTypePaiement?.toString()}
            type="normal"
            elementAttr={buttonAttributes}
            onClick={onClickBtnRapide}
        />
    ), [typePaiementsBtn, onClickBtnRapide])

    const {envoitcommand, isTpvServiceActived} = useTpv()
    const formatMontant = useMemo(() => ({type: "fixedPoint", precision: 2}), []);
    return (
        <div className={"gestionPaiement"}>
            <div style={{flexGrow: 1}}>
                <GestionPaiementToolbar
                    ajouterOptions={{
                        click: ajouterClick
                    }}
                    sauvegarderOptions={{
                        disabled: !isFieldModifier,
                        click: (e) => {
                            e.component.option("disabled", true);
                            sauvegarderClick()
                        }
                    }}
                    modifierOptions={modifierOptions}
                    annulerOptions={annulerOptions}
                />
                <div className='wrapper-cta' style={{gap: "0.5rem", flexWrap: "wrap"}}>
                    <Button
                        text="TPV"
                        type="normal"
                        visible={isTpvServiceActived}
                        elementAttr={buttonAttributes}
                        onClick={() => setIsSaisiePaiement("tpv")}
                    />
                    <Button
                        text="BAMBORA"
                        type="normal"
                        elementAttr={buttonAttributes}
                        onClick={() => setIsSaisiePaiement("bambora")}
                    />
                    <>
                        {buttonsTypePaiement}
                    </>
                </div>
                <div style={{flexGrow: 1}}>
                    <DataGrid
                        key={"data-grid-paiement"}
                        ref={dataGridRef}
                        dataSource={dataSource}
                        onFocusedRowChanged={onFocusedRowChanged}
                        onInitNewRow={onInitNewRow}
                        showBorders={true}
                        focusedRowEnabled={true}
                        filterValue={filterValue}
                        repaintChangesOnly={true}
                        autoNavigateToFocusedRow={false}
                        errorRowEnabled={true}
                        customizeColumns={customizeColumns}
                    >
                        <Editing newRowPosition={"first"} mode={"cell"} startEditAction={"click"} allowAdding={false} allowDeleting={allowDeleting} allowUpdating={allowUpdating}/>
                        <Column dataType={"object"} dataField={"idTypePaiement"} width={"15%"} caption={"Type paiement"}>
                            <Lookup {...typePaiementEditorOptions} />
                        </Column>
                        <Column dataType={"number"} dataField={"montant"} width={"10%"} format={formatMontant}/>
                        <Column dataType={"string"} dataField={"reference"} width={"15%"}/>
                        <Column caption={"Client"} alignment={"center"} width={"15%"} dataType={"object"} dataField={"idClient"} cellRender={ClientSelectBox} editCellRender={ClientSelectBox}/>
                        <Column dataType={"date"} dataField={"datePaiement"} width={"10%"}/>
                        <Column dataType={"object"} allowEditing={false} dataField={"idUsagerModification"} width={"15%"} caption={"Usager"}>
                            <Lookup {...usagerEditorOptions} />
                        </Column>
                        <Column dataType={"number"} allowEditing={false} dataField={"maj"} width={"5%"}/>
                        <Column dataType={"string"} allowEditing={false} dataField={"z"} width={"5%"}/>
                        <Column dataType={"string"} allowEditing={false} dataField={"noRecu"} width={"5%"}/>
                        <Column dataType={"string"} allowEditing={false} dataField={"noDepot"} width={"5%"}/>
                        <Column dataType={"date"} dataField={"dateSuppression"} visible={false}/>
                        <Column type="buttons" width={32}/>
                    </DataGrid>
                </div>
            </div>
            <div>
                <div className='soldeDu'>
                    <p> Solde : {montantDu.toFixed(2)} $</p>
                </div>
            </div>
            <PopupGestionClient isModeSelection={isModeModify} onSelectionchanged={client => {
                setPaiements(prev => {
                    return prev.map<IPaiement>((p) => {
                            if (p.idPaiement.equals(focusedRow?.idPaiement))
                                return {...p, idClient: client.idClient || Guid.empty}
                            return p;
                        }
                    )
                })
                setIsFieldModifier(true);
            }}/>
            <PopupPage
                titre="Confirmation du montant"
                isPopupOpen={isSaisiePaiement !== false}
                onClose={() => setIsSaisiePaiement(false)}
                mode={"ajout"}
                height={"auto"}
                width={"42rem"}
                showOk={false}
                showAnnuler={false}
            >
                <GestionSaisieDePaiement
                    setIsSaisiePaiement={setIsSaisiePaiement}
                    showSaisieCarte={isSaisiePaiement !== "tpv"}
                    idClient={idClient}
                    currentPaiement={focusedRow}
                    onConfirm={async (e) => {
                        if (isSaisiePaiement === "tpv") {
                            envoitcommand(e.montant, e.typePaiement)
                                .then(async result => {
                                    if (!result.approved) {
                                        setTitle("Attention");
                                        setMessage(`Paiement Refusé : ${result.reference}`)
                                        setButtonType("Ok");
                                        setIsMessageBoxOpen(true)
                                        return;
                                    }

                                    let typePaiement = typePaiementsBtn.find(f => f.modePaiement === result.typePaiement);
                                    const newRow = await getPaiement({customPath: 'paiement/default', returnOnly: true});
                                    const row: IPaiement = {
                                        ...newRow,
                                        idClient: idClient || Guid.empty,
                                        idTypePaiement: typePaiement?.idTypePaiement || Guid.empty,
                                        idAuxiliaire: typeAuxiliaire === 'RE' ? id || Guid.empty : Guid.empty,
                                        idFacturationEntete: typeAuxiliaire !== 'RE' ? id || Guid.empty : Guid.empty,
                                        idUsagerModification: user?.idUsager || Guid.empty,
                                        idUsagerCreation: user?.idUsager || Guid.empty,
                                        dateCreation: new Date(),
                                        dateModification: new Date()
                                    }
                                });
                        } else {
                            const paramPaiementWeb: IParamPaiementWeb = {
                                carteCredit: {
                                    cardNumber: e.cardNumber,
                                    expirationMonth: e.cardExpiration.split('-')[0],
                                    expirationYear: e.cardExpiration.split('-')[1],
                                    cVV: e.cardVcc,
                                    cardHolderName: e.nomClient,
                                },
                                idAuxiliaire: (typeAuxiliaire === TypeAuxiliaire.Reservation ? id : Guid.empty) || Guid.empty,
                                idClient: idClient || Guid.empty,
                                idFacturationEntete: (typeAuxiliaire !== TypeAuxiliaire.Reservation ? id : Guid.empty) || Guid.empty,
                                idUsager: user?.idUsager || Guid.empty,
                                montant: e.montant,
                                transactionId: e.noTransaction.trim(),
                                transactionType: e.typePaiement,
                                typeAuxiliaire: typeAuxiliaire,
                                paiementProfile: e.ProfilePaiement?.profile
                            }

                            const result = await postPaiement(paramPaiementWeb, "paiement/WebPayment", true);
                        }
                        setIsSaisiePaiement(false)
                        getPaiements();
                    }}
                    montantDu={montantDu || 0}
                />
            </PopupPage>
            <MessageBox onConfirme={() => {
            }}/>
        </div>
    )
}

export default GestionPaiement;